import { Council, Society } from 'types';

export const getCouncilDetailsUrl = (
  council: Council,
  society: Society
): string =>
  society?.configuration?.hasCouncilsV2Enabled
    ? `/detalle-consejo-v2/${council.society}/${council._id}`
    : `/detalle-consejo/${council.society}/${council._id}`;

export const getCouncilVoteUrl = (council: Council, memberId: string): string =>
  `/voto-consejo/${council.society}/${council._id}/${memberId}`;

export const getCouncilDetailsUrlByRole = (
  council: Council,
  isAdmin: boolean,
  isDirector: boolean,
  directorId: string,
  society: Society
): string => {
  if (isAdmin) {
    return getCouncilDetailsUrl(council, society);
  }

  if (isDirector) {
    return getCouncilVoteUrl(council, directorId);
  }

  return '';
};
